var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"xt-content"},[_c('h1',{staticClass:"xt-page-search-statistics"},[_vm._v("\n    为你搜索到\n    "),_c('span',{domProps:{"textContent":_vm._s(_vm.Pagination.total)}}),_vm._v(" 个相关结果\n  ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }